import React, { FC, useEffect } from 'react';
import { useQuery } from 'react-query';
import API from 'core/Api';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useHistory, useParams } from 'react-router';
import InnerWrapper from '../InnerWrapper';
import CategoryTabs from './components/CategoryTabs';
import FormTable from './components/FormTable';
import { IMultiActionsByCategory } from './types';

const Screen: FC = () => {
  const { client } = useActiveClientContext();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  useEffect(() => {
    if (!id)
      history.replace({
        pathname: buildClientUrl('/structure/multi-actions/1', client),
      });
  }, []);

  const fetchEntity = (): Promise<IMultiActionsByCategory> => {
    return API.get<IMultiActionsByCategory>(`action-configs/table?category_id=${id}`)
      .then(res => res.data)
      .catch(err => {
        throw err;
      });
  };

  const { isLoading, error, data } = useQuery<IMultiActionsByCategory, Error>(
    [buildClientEntity('multi-actions', client), { categoryId: id }],
    (): Promise<IMultiActionsByCategory> => {
      return fetchEntity();
    },
    {
      enabled: !!id,
    }
  );

  return (
    <InnerWrapper
      isLoading={isLoading}
      error={error}
    >
      <CategoryTabs />
      {data && <FormTable data={data} />}
    </InnerWrapper>
  );
};

export default Screen;
